import React, { Fragment } from 'react'
import SectionsList from './SectionsList'
import ArticlesList from '../Article/ArticlesList'
import ContentService from '../../services/content'

const openSection = (redirect) => (sectionId) => {
    const url = ContentService.generateSectionUrl(sectionId)
    redirect(url)
}

const openArticle = (redirect) => (articleId) => {
  const url = ContentService.generateArticleUrl(articleId)
  redirect(url)
}

export default ({section, articles, redirect}) => (
  <Fragment>
    <h1>{section.name}</h1>
    <p>{section.title}</p>
    <SectionsList
      sections={section.sections}
      openSection={openSection(redirect)}
    />
    <ArticlesList
      articles={articles}
      openArticle={openArticle(redirect)}
    />
  </Fragment>
)

